import { render, staticRenderFns } from "./MandateDataPP.vue?vue&type=template&id=429b24ba&"
import script from "./MandateDataPP.vue?vue&type=script&lang=js&"
export * from "./MandateDataPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports